module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-搜索-搜索框内置-蓝色.60fa1.png";